import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// material-ui icons
// @material-ui/core components
import { withStyles } from "tss-react/mui";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import SaveButton from "../../components/CustomInput/SaveButton";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import { endOfMonth, startOfMonth, subMonths } from "date-fns";
import { DatePicker } from "@mui/x-date-pickers";

class Index extends React.Component {
  state = {
    dateFrom: startOfMonth(subMonths(new Date(), 1)),
    dateUntil: endOfMonth(subMonths(new Date(), 1)),
    saving: false,
  };

  handleDateChange(target, value) {
    if (target === "dateFrom") {
      this.setState({
        dateFrom: value,
      });
    }
    if (target === "dateUntil") {
      this.setState({
        dateUntil: value,
      });
    }
  }

  downLoad() {
    let downloadUrl =
      "/core/reseller/export/?type=orders&key=sadlgfqpihrtgkjrjaensndui&start=" +
      this.state.dateFrom.getTime() / 1000 +
      "&stop=" +
      Math.floor(this.state.dateUntil.getTime() / 1000);
    window.open(downloadUrl);
  }

  downLoadSms() {
    let downloadUrl =
      "/manager/core/subsInvoice/generateSmsPerInvoice/?start=" +
      this.state.dateFrom.unix() +
      "&stop=" +
      this.state.dateUntil.unix();
    window.open(downloadUrl);
  }

  downloadTransactions() {
    let downloadUrl =
      "/core/reseller/export/?type=transactions&key=sadlgfqpihrtgkjrjaensndui&start=" +
      this.state.dateFrom.unix() +
      "&stop=" +
      this.state.dateUntil.unix();
    window.open(downloadUrl);
  }

  downloadAllTransactions() {
    let downloadUrl =
      "/core/reseller/export/?type=alltransactions&key=sadlgfqpihrtgkjrjaensndui&start=" +
      this.state.dateFrom.unix() +
      "&stop=" +
      this.state.dateUntil.unix();
    window.open(downloadUrl);
  }

  downloadVenueUsageReport() {
    let downloadUrl = "/core/reseller/export/?type=ordersPerVenue&key=sadlgfqpihrtgkjrjaensndui";
    window.open(downloadUrl);
  }

  downloadErrorReport() {
    let downloadUrl = "/core/export/?type=downloadErrorReport&key=WEf213@!@3!@Wasdfagrgwa";
    window.open(downloadUrl);
  }

  downloadLicenseExport() {
    let downloadUrl = "/core/export/?type=downloadLicenseExport&key=WEf213@!@3!@Wasdfagrgwa";
    window.open(downloadUrl);
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <MainNavbar paginaTitel={"Exporten resellers rapportage"} />
        <GridContainer>
          <GridItem md={2} xs={12}>
            <DatePicker
              closeOnSelect
              label={<TranslationWrapper tDefault={"Van"} tKey={"global.van"} />}
              maxDate={this.state.dateUntil}
              onChange={(date) => this.handleDateChange("dateFrom", date)}
              value={this.state.dateFrom}
            />
          </GridItem>
          <GridItem md={2} xs={12}>
            <DatePicker
              closeOnSelect
              label={<TranslationWrapper tDefault={"Tot"} tKey={"global.tot"} />}
              minDate={this.state.dateFrom}
              onChange={(date) => this.handleDateChange("dateUntil", date)}
              value={this.state.dateUntil}
            />
          </GridItem>
          <GridItem xs={12}>
            <SaveButton
              buttonText={
                <TranslationWrapper tDefault={"Download report"} tKey={"tafels.modal.resexp.form.button.genDownload"} />
              }
              onClick={() => {
                this.downLoad();
              }}
              saving={this.state.saving}
            />
          </GridItem>
          <GridItem xs={12}>
            <SaveButton
              buttonText={
                <TranslationWrapper
                  tDefault={"Download sms and transactions report"}
                  tKey={"tafels.modal.resexp.form.button.Download sms report"}
                />
              }
              onClick={() => {
                this.downLoadSms();
              }}
              saving={this.state.saving}
            />
          </GridItem>
          <GridItem xs={12}>
            <SaveButton
              buttonText={
                <TranslationWrapper
                  tDefault={"Download transaction report"}
                  tKey={"tafels.modal.resexp.form.button.Download transaction report"}
                />
              }
              onClick={() => {
                this.downloadTransactions();
              }}
              saving={this.state.saving}
            />
          </GridItem>
          <GridItem xs={12}>
            <SaveButton
              buttonText={
                <TranslationWrapper
                  tDefault={"Download all transaction report (internal usage)"}
                  tKey={"tafels.modal.resexp.form.button.Download internal report"}
                />
              }
              onClick={() => {
                this.downloadAllTransactions();
              }}
              saving={this.state.saving}
            />
          </GridItem>
          <GridItem xs={12}>
            <SaveButton
              buttonText={
                <TranslationWrapper
                  tDefault={"Download overview of order per venue"}
                  tKey={"resexp.downloadvenueusagereport"}
                />
              }
              onClick={() => {
                this.downloadVenueUsageReport();
              }}
              saving={this.state.saving}
            />
          </GridItem>
          <GridItem xs={12}>
            <SaveButton
              buttonText={
                <TranslationWrapper
                  tDefault={"Download errors report last 24 hours"}
                  tKey={"resexp.downloaderrorreport"}
                />
              }
              onClick={() => {
                this.downloadErrorReport();
              }}
              saving={this.state.saving}
            />
          </GridItem>
          <GridItem xs={12}>
            <SaveButton
              buttonText={
                <TranslationWrapper
                  tDefault={"Download export of all active licenses"}
                  tKey={"resexp.downloadLicenseExport"}
                />
              }
              onClick={() => {
                this.downloadLicenseExport();
              }}
              saving={this.state.saving}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(withStyles(Index, tafelStyle));
